<template>
  <div>
    <div class="sku-info-header__wrapper">
      <div class="sku-base-info__wrapper">
        <div class="sku-img__wrapper">
          <el-image
            :src="
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg'
            "
            :preview-src-list="[
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg',
            ]"
            style="width: 110px;height: 110px;"
          >
            <div slot="error" class="image-slot">
              <img src="/image/static/img/nopic-square.jpg" />
            </div>
          </el-image>
        </div>
        <div style="flex:1;">
          <div class="d-flex bt-1 bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_evg_sku_number') || 'SKU No'
              }}</template>
              <template v-slot>{{ formData.evgSkuNo }}</template>
            </LabelValue>
            <LabelValue style="flex: 0.7 !important;">
              <template v-slot:label>{{
                $l('label_key_UPC') || 'UPC'
              }}</template>
              <template v-slot>{{ formData.eanCode }}</template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_product_name') || '产品名称'
              }}</template>
              <template v-slot>
                <div style="padding: 5px 0;">
                  <span>{{ formData.goodsName }}</span>
                  <br />
                  <span>{{ formData.goodsNameEn }}</span>
                </div>
              </template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_customer') || 'Customer'
              }}</template>
              <template v-slot>{{ formData.custName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_brand') || 'Brand'
              }}</template>
              <template v-slot>{{ formData.brandName }}</template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_category') || 'Category'
              }}</template>
              <template v-slot>{{ formData.categoryFullName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_collection') || 'Collection'
              }}</template>
              <template v-slot>{{ formData.collectionName }}</template>
            </LabelValue>
          </div>
        </div>
      </div>
    </div>
    <div class="side-frame-success d-flex ">
      <span>
        {{ $l('title_sales_warehouse') || '海外仓库' }}：{{
          formData.ecomWarehouseName
        }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>
        {{ $l('form_label_region') || '国家' }}：{{ formData.regionName }}</span
      >
      <el-divider direction="vertical"> </el-divider>
      <b-badge
        style="font-size: 12px;padding: 5px 10px;"
        :variant="
          formData.invSkuSetStatus === 'Y'
            ? 'success'
            : formData.invSkuSetStatus === 'S' ||
              formData.invSkuSetStatus === 'D'
            ? 'danger'
            : formData.invSkuSetStatus === 'W'
            ? 'warning'
            : 'primary'
        "
      >
        {{ formData.v_invSkuSetStatus || '-' }}
      </b-badge>
      <span class="ml-2">
        {{ $l('title_modify') || 'Modify' }}：
        {{ formData.modifyByName ? formData.modifyByName : '--' }} at
        {{ formData.modifyDate ? formData.modifyDate : '--' }}</span
      >
    </div>

    <el-form
      ref="form"
      size="mini"
      :rules="rules"
      :model="formData"
      :disabled="disabled"
    >
      <div class="mt-2">
        <div class="summary_title">
          {{ $l('title_wh_product_definition') || '仓库产品定义' }}
        </div>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_whSkuNo') || '仓库产品SKU'"
              prop="whSkuNo"
            >
              <el-input
                v-model="formData.whSkuNo"
                :placeholder="
                  $l('form_placeholder_whSkuNo') || '请输入仓库产品SKU'
                "
                clearable
                show-word-limit
                maxlength="50"
                :disabled="isDisabled"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_whSkuBarcode') || '仓库产品条码'"
              prop="whSkuBarcode"
            >
              <el-input
                v-model="formData.whSkuBarcode"
                :disabled="isDisabled"
                :placeholder="
                  $l('form_placeholder_whSkuBarcode') || '请输入仓库产品条码'
                "
                maxlength="50"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_whReferenceNo') || '自定义编号'"
              prop="whReferenceNo"
            >
              <el-input
                v-model="formData.whReferenceNo"
                :placeholder="
                  $l('form_placeholder_whReferenceNo') || '请输入自定义编号'
                "
                maxlength="50"
                :disabled="isDisabled"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_whProductTitle') || '仓库产品中文名称'"
              prop="whProductTitle"
            >
              <el-input
                v-model="formData.whProductTitle"
                clearable
                show-word-limit
                maxlength="100"
                :disabled="isDisabled"
                :placeholder="
                  $l('form_placeholder_whProductTitle') ||
                    '请输入仓库产品中文名称'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_whProductTitleEn') || '仓库产品英文名称'"
              prop="whProductTitleEn"
            >
              <el-input
                v-model="formData.whProductTitleEn"
                clearable
                show-word-limit
                maxlength="100"
                :disabled="isDisabled"
                :placeholder="
                  $l('form_placeholder_whProductTitleEn') ||
                    '请输入仓库产品英文名称'
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_whAccount') || '仓库账号'"
              prop="whAccount"
            >
              <dict-select
                v-model="formData.whAccount"
                url="/ecomorder/overseas/inv/sku/set/select/account"
                :placeholder="
                  $l('placeholder_shelves_select_whAccount') || '请选择仓库账号'
                "
                :body="{
                  ecomWarehouseCode: formData.ecomWarehouseCode,
                }"
                :disabled="isDisabled"
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_warningInvQty') || '预警库存数量'"
              prop="warningInvQty"
            >
              <el-input-number
                controls-position="right"
                size="small"
                style="width: 100%"
                :min="0"
                :step="1"
                v-model="formData.warningInvQty"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_declaredValue') || '申报货值（美元）'"
              prop="declaredValue"
            >
              <el-input-number
                controls-position="right"
                size="small"
                style="width: 100%"
                :min="0"
                :precision="4"
                :disabled="isDisabled"
                v-model="formData.declaredValue"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="summary_title">
          {{ $l('title_wh_product_property') || '产品属性' }}
        </div>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_pkgLength') || '单品包装长cm'"
              prop="pkgLength"
            >
              <el-input-number
                :controls="false"
                size="small"
                style="width: 100%;"
                class="number-input"
                :min="0"
                :precision="2"
                v-model="formData.pkgLength"
              ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_pkgWidth') || '单品包装宽cm'"
              prop="pkgWidth"
            >
              <el-input-number
                :controls="false"
                size="small"
                style="width: 100%;"
                class="number-input"
                :min="0"
                :precision="2"
                v-model="formData.pkgWidth"
              ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_pkgHeight') || '单品包装高cm'"
              prop="pkgHeight"
            >
              <el-input-number
                :controls="false"
                size="small"
                style="width: 100%;"
                class="number-input"
                :min="0"
                :precision="2"
                v-model="formData.pkgHeight"
              ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_pkgWeight') || '单品包装重量kg'"
              prop="pkgWeight"
            >
              <el-input-number
                :controls="false"
                size="small"
                style="width: 100%;"
                class="number-input"
                :min="0"
                :precision="4"
                v-model="formData.pkgWeight"
              ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_pkgCbm') || '单品包装CBM（立方米）'"
              prop="pkgCbm"
            >
            <el-input v-model="pkgCbm" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import LabelValue from './label-value.vue'
import { multiply, divideRound } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  components: { LabelValue },
  props: {
    invSkuSetCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      chooseEvgSkuVisible: false,
      rules: {
        whSkuNo: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('rules_detail_whSkuNo') || '请输入仓库产品SKU',
          },
        ],
        // whSkuBarcode: [
        //   {
        //     required: true,
        //     trigger: 'blur',
        //     message:
        //       this.$l('rules_detail_whSkuBarcode') || '请输入仓库产品条码',
        //   },
        // ],
        whProductTitle: [
          {
            required: true,
            trigger: 'blur',
            message:
              this.$l('rules_detail_whProductTitle') ||
              '请输入仓库产品中文名称',
          },
        ],
        whReferenceNo: [
          {
            required: true,
            trigger: 'blur',
            message:
              this.$l('rules_detail_whReferenceNo') || '请输入自定义编号',
          },
        ],
        whProductTitleEn: [
          {
            required: true,
            trigger: 'blur',
            message:
              this.$l('rules_detail_whProductTitleEn') ||
              '请输入仓库产品英文名称',
          },
        ],
        warningInvQty: [
          {
            required: true,
            trigger: 'blur',
            message:
              this.$l('rules_detail_warningInvQty') || '请输入预警库存数量',
          },
        ],
        whAccount: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('rules_detail_whAccount') || '请选择仓库账号',
          },
        ],
      },
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    isDisabled() {
      return !['N'].includes(this.formData.invSkuSetStatus)
    },
    pkgCbm() {
      return divideRound(
        multiply(
          multiply(this.formData.pkgLength, this.formData.pkgWidth),
          this.formData.pkgHeight
        ),
        1000000,
        8
      )
    },
  },
  methods: {
    init() {
      if (!this.invSkuSetCode) return
      this.$api
        .ecomOverseasInvSkuSetDetailApi({
          invSkuSetCode: this.invSkuSetCode,
        })
        .then((res) => {
          this.formData = res?.body || {}
        })
    },
    async validate() {
      const formResult = await validate.formValidate([this.$refs.form])
      return formResult
    },
    async save() {
      if (!(await this.validate())) return (this.backDialogVisible = false)

      const params = { ...this.formData }
      this.loadingOpen()
      const res = await this.$api
        .ecomOverseasInvSkuSetEditorApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.sku-base-info__wrapper {
  display: flex;
  margin-bottom: 20px;
  .sku-img__wrapper {
    border: 1px solid #efefef;
    border-right: none;
    width: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.side-frame-success {
  padding: 1px 7px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #6c6c6c;
}
.bt-1 {
  border-top: 1px solid #efefef;
}
.bb-1 {
  border-bottom: 1px solid #efefef;
}
.bl-1 {
  border-left: 1px solid #efefef;
}
.summary_title {
  font-size: 14px;
  color: #101010;
  font-weight: 600;
  margin-bottom: 12px;
}
::v-deep {
  .number-input {
    .el-input__inner {
      text-align: left !important;
    }
  }
}
</style>
